export const locationGroupSchema = {
    displayName: 'location group',
    type: 'object',
    fields: {
        name: {
            type: 'shortString',
            required: true,
        },
        orgId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
            required: true,
        },
        locationIds: {
            type: 'array',
            elementType: 'mongoId',
            required: true,
            minCount: 1,
            displayName: 'Locations',
            ui: 'table',
            placeholder: 'Select Locations',
        },
    },
};
//# sourceMappingURL=location_group_schema.js.map